import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';

const BaseColumnOptions = [
  ConstituentSearchColumn.CONSTITUENT_CATEGORIES,
  ConstituentSearchColumn.DEVELOPERS,
  ConstituentSearchColumn.LAST_INTERACTION_DATE,
  ConstituentSearchColumn.PRIMARY_PHONE,
  ConstituentSearchColumn.BIO,
  ConstituentSearchColumn.LABELS,
  ConstituentSearchColumn.DATE_OF_BIRTH,
  ConstituentSearchColumn.PRIMARY_EMAIL,
  // ConstituentSearchColumn.PRIMARY_CITY,
  // ConstituentSearchColumn.PRIMARY_STATE,
  // ConstituentSearchColumn.PRIMARY_COUNTRY,
  ConstituentSearchColumn.NUM_CONNECTIONS,
];

export default BaseColumnOptions;
